import { Component, OnInit } from '@angular/core';
import { ActionLogService } from '../../../../core/services/action-log.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { HeaderService } from '../../../../core/services/header.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-left-panel',
  templateUrl: './client-left-panel.component.html',
  styleUrls: ['./client-left-panel.component.scss']
})
export class ClientLeftPanelComponent implements OnInit {
  loggedUserName: string = this.authenticationService.currentUserValue?.username;;
  columnsLocalStorageNames: string[] = ['allNodeListColoumnsInfo', 'nodeListColoumnsInfo', 'userListColumnsInfo']

  constructor(
    private headerService: HeaderService,
    private actionLogService: ActionLogService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  logOut() {
    this.clearLocalStorage();
    this.headerService.toRedirectSessions = true;
    this.headerService.toRedirectDeployments = true;
    this.headerService.updateDeploymentList(null);
    this.actionLogService.addActionLog("SyncHPC", 'SignOut', this.loggedUserName, this.loggedUserName, 'User', 'Sign Out')
    this.authenticationService.logout(true);
    //this.router.navigate(['Client/Login'], { queryParams: { user: this.loggedUserName } }).then(() => {window.location.reload()}) ;
  }

  clearLocalStorage() {
    this.columnsLocalStorageNames.forEach(el => localStorage.removeItem(el))
  }
}
